import React, { useState, useEffect, useContext } from 'react';

import { Box } from '@material-ui/core';

import LogoCliqueRetire from '../../assets/images/LogoCliqueHorizontal.svg';
import LogoCorreios from '../../assets/images/logoCorreios.png';
import LogoVTEX from '../../assets/images/VTEXlogo.svg';
import LogoMemphis from '../../assets/images/memphis-logo.png';
import { GeneralContext } from '../../core/app-context/GeneralContext';
import { ModalCliqueRetire } from './components/ModalCliqueRetire';
import { ModalCorreios } from './components/ModalCorreios';
import { ModalVtex } from './components/ModalVtex';
import { ModalMemphis } from './components/ModalMemphis';
import { RowPlataform } from './components/RowPlataform';
import { useGetIntegrationsStatus } from './hooks/use-get-integrations-status';
import { useDeleteCliqueRetireCredentials } from './hooks/use-delete-cliqueretire-credentials';
import { useDeleteCorreiosCredentials } from './hooks/use-delete-correios-credentials';
import { useDeleteVtexCredentials } from './hooks/use-delete-vtex-credentials';
import { useDeleteMemphisCredentials } from './hooks/use-delete-memphis-credentials';
import { ConfigCard } from '../../shared/components/ConfigCard';
import { Divider } from './styles';
import { PrivatePageStructure } from '../../shared/components/PrivatePageStructure';

function Integrations() {
  const { setSideMenu, setIdMenuSelected, store } = useContext(GeneralContext);

  useEffect(() => {
    setSideMenu('reversa');
    setIdMenuSelected('integrations');
  }, [setSideMenu, setIdMenuSelected]);

  const storeId = store?.id;
  const [openSettingCorreios, setOpenSettingCorreios] = useState(false);
  const [openSettingCliqueRetire, setOpenSettingCliqueRetire] = useState(false);
  const [openSettingVtex, setOpenSettingVtex] = useState(false);
  const [openSettingMemphis, setOpenSettingMemphis] = useState(false);
  const {
    getIntegrationsStatus,
    status: integrationStatus,
    loading,
  } = useGetIntegrationsStatus({ storeId });
  const { deleteCliqueRetireCredentials } = useDeleteCliqueRetireCredentials();
  const { deleteCorreiosCredentials } = useDeleteCorreiosCredentials();
  const { deleteVtexCredentials } = useDeleteVtexCredentials();
  const { deleteMemphisCredentials } = useDeleteMemphisCredentials();

  useEffect(() => {
    if (storeId) {
      getIntegrationsStatus(storeId);
    }
  }, [
    openSettingCorreios,
    openSettingCliqueRetire,
    openSettingVtex,
    openSettingMemphis,
  ]);

  return (
    <PrivatePageStructure title="Integrações" disableButtons loading={loading}>
      <ConfigCard title="Transportadoras" flexDirection="column">
        <RowPlataform
          name="Clique Retire"
          integrationStatus={
            integrationStatus && integrationStatus.cliqueRetire
          }
          logo={LogoCliqueRetire}
          onClick={() => setOpenSettingCliqueRetire(true)}
          onDelete={async () => {
            await deleteCliqueRetireCredentials(storeId);
            await getIntegrationsStatus(storeId);
          }}
        />
        <Divider />
        <RowPlataform
          name="Correios"
          integrationStatus={integrationStatus && integrationStatus.correios}
          logo={LogoCorreios}
          onClick={() => setOpenSettingCorreios(true)}
          onDelete={async () => {
            await deleteCorreiosCredentials(storeId);
            await getIntegrationsStatus(storeId);
          }}
        />
      </ConfigCard>
      <Box sx={{ height: '20px' }} />
      <ConfigCard title="Plataformas" flexDirection="column">
        <RowPlataform
          name="VTEX"
          integrationStatus={integrationStatus && integrationStatus.vtex}
          logo={LogoVTEX}
          onClick={() => setOpenSettingVtex(true)}
          onDelete={async () => {
            await deleteVtexCredentials(storeId);
            await getIntegrationsStatus(storeId);
          }}
        />
        <Divider />
        <RowPlataform
          name="Memphis"
          integrationStatus={integrationStatus && integrationStatus.memphis}
          logo={LogoMemphis}
          onClick={() => setOpenSettingMemphis(true)}
          onDelete={async () => {
            await deleteMemphisCredentials(storeId);
            await getIntegrationsStatus(storeId);
          }}
        />
      </ConfigCard>
      <ModalCliqueRetire
        open={openSettingCliqueRetire}
        storeId={storeId}
        handleClose={() => setOpenSettingCliqueRetire(false)}
      />
      <ModalCorreios
        open={openSettingCorreios}
        storeId={storeId}
        handleClose={() => setOpenSettingCorreios(false)}
      />
      <ModalVtex
        open={openSettingVtex}
        storeId={storeId}
        handleClose={() => setOpenSettingVtex(false)}
      />
      <ModalMemphis
        open={openSettingMemphis}
        storeId={storeId}
        handleClose={() => setOpenSettingMemphis(false)}
      />
    </PrivatePageStructure>
  );
}

export default Integrations;
